import { closingCross } from "@/designSystemIcons";
import { useEscape } from "@/hooks/useKeyboardShortcut";
import { useOutsideClick } from "@/hooks/useOutsideClick";
import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";

type Props = {
  onDismiss: () => void;
  children: React.ReactNode;
  title?: string;
  size?: "small" | "medium" | "large";
};

const ActionModal = ({
  onDismiss,
  children,
  title,
  size = "medium",
}: Props) => {
  useEscape(() => {
    onDismiss();
  });
  const [isVisible, setIsVisible] = useState(false);
  const ref = useOutsideClick(() => {
    onDismiss();
  });
  useEffect(() => {
    setIsVisible(true);
    return () => {
      setIsVisible(false);
    };
  }, []);

  return (
    <div
      className={cn(
        "fixed top-0 left-0 mobile:w-full mobile:h-full w-screen h-screen px-4 mobile:px-0 bg-black/50 z-20 flex justify-center transition-opacity duration-200",
        isVisible ? "opacity-100" : "opacity-0",
      )}
    >
      <div
        className={cn(
          "relative bg-gradient-side-bar mobile:border rounded-lg mobile:border-white/10 mobile:rounded-xl top-24 mobile:top-36 transition-opacity duration-200 p-7 mobile:p-10",
          isVisible ? "opacity-100" : "opacity-0",
          size === "small" && "w-4/5 mobile:w-[400px] h-fit",
          size === "medium" &&
            "w-screen h-screen mobile:w-[800px] mobile:h-[372px]",
          size === "large" &&
            "w-screen h-screen mobile:w-[1200px] mobile:h-fit",
        )}
        ref={ref}
      >
        {title && (
          <h3 className="text-lg text-center absolute top-4 left-1/2 -translate-x-1/2">
            {title}
          </h3>
        )}
        {children}
        <button
          className="absolute top-4 right-4 mobile:p-2 mobile:m-0 fill-secondary-dark -m-2 p-4"
          onClick={onDismiss}
        >
          {closingCross}
        </button>
      </div>
    </div>
  );
};

export default ActionModal;
